var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddNote = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4764_2142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1722 2.83325V10.0381C17.1722 10.6017 16.9483 11.1422 16.5498 11.5407L12.4213 15.6692C12.0228 16.0677 11.4823 16.2916 10.9188 16.2916H3.71387C2.54027 16.2916 1.58887 15.3402 1.58887 14.1666V2.83325C1.58887 1.65964 2.54027 0.708252 3.71387 0.708252H15.0472C16.2208 0.708252 17.1722 1.65965 17.1722 2.83325ZM16.3366 10.6249C16.267 10.7779 16.17 10.9187 16.0489 11.0399L11.9205 15.1683C11.7994 15.2894 11.6585 15.3864 11.5055 15.456V11.6874C11.5055 11.1006 11.9812 10.6249 12.568 10.6249H16.3366ZM16.4639 9.91658H12.568C11.59 9.91658 10.7972 10.7094 10.7972 11.6874V15.5833H3.71387C2.93146 15.5833 2.2972 14.949 2.2972 14.1666V2.83325C2.2972 2.05085 2.93146 1.41659 3.71387 1.41659H15.0472C15.8296 1.41659 16.4639 2.05085 16.4639 2.83325V9.91658Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02604 10.6251C8.77709 10.6251 8.57528 10.4233 8.57528 10.1743V8.59667H6.99763C6.74868 8.59667 6.54688 8.39487 6.54688 8.14591C6.54688 7.89696 6.74868 7.69516 6.99763 7.69516H8.57528V6.11751C8.57528 5.86855 8.77709 5.66675 9.02604 5.66675C9.275 5.66675 9.4768 5.86855 9.4768 6.11751V7.69516H11.0545C11.3034 7.69516 11.5052 7.89696 11.5052 8.14591C11.5052 8.39487 11.3034 8.59667 11.0545 8.59667H9.4768V10.1743C9.4768 10.4233 9.275 10.6251 9.02604 10.6251Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4764_2142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.880371)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddNote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add_note.db4f5758.svg";
export { ForwardRef as ReactComponent };